<template>
  <v-card class="tab-card bg-dot-img">
    <v-tabs
      v-model="tab"
    >
     <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" class="tabs-box" >
          Public Provident Fund
      </v-tab>

      <v-tab href="#tab-2" class="tabs-box">
          Employee Provident Fund
      </v-tab>

      <v-tab href="#tab-3" class="tabs-box">
          National Pension Scheme
      </v-tab>

      <v-tab href="#tab-4" class="tabs-box" >
         Annuity
      </v-tab>

      <v-tab href="#tab-5" class="tabs-box">
         Monthly Income Scheme
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <v-tab-item
        value="tab-1"
        
      >
      <ListProvidedFund />
          
      </v-tab-item>
      <v-tab-item
        value="tab-2"
        
      >
        <ListEmployeeProvidentFund />
        
      </v-tab-item>

      <v-tab-item
        value="tab-3"
        
      >
    
     <ListNationalScheme />

      </v-tab-item>

      <v-tab-item
       value="tab-4"
      >
     <annuitySchemeList />
      </v-tab-item>

      <v-tab-item
         value="tab-5"
      >
       <ListMonthlyScheme />
      </v-tab-item>
      
    </v-tabs-items>
  </v-card>
</template>

<script>

  import annuitySchemeList from './AnnuityScheme/ListAnnuityScheme'; 
  import ListProvidedFund from './ProvidedFund/ListProvidedFund';
  import ListEmployeeProvidentFund from './EmployeeProvidedFund/ListEmployeeProvidentFund'; 
  import ListNationalScheme from './NationalPensionScheme/ListNationalScheme';
  import ListMonthlyScheme from './MonthlyIncomeScheme/ListMonthlyScheme';
   
  export default {
   components: {
    annuitySchemeList,
    ListProvidedFund,
    ListEmployeeProvidentFund,
    ListNationalScheme,
    ListMonthlyScheme
        },
    data () {
      return {
        tab: this.$route.params.tab,
        text: '',
        tabName: '',
      }
    },
    beforeCreate(){
    },
    methods:{
      CheckTab(tabName)
      {
        //this.tabName = tabName;;
      }
    },
  }
</script>